// extracted by mini-css-extract-plugin
export var logotype = "logotype-module--logotype--krpVS";
export var sbShowMain = "logotype-module--sb-show-main--9+IsP";